import { ResponsibleForUnitValues, SubscriptionStoreValue } from 'app/area/user-profile/subscriptions/types';
import { ComplexValue } from 'app/types-shared';

export const ACTION = {
  REQUEST_LOAD_SUBSCRIPTIONS: 'SUBSCRIPTIONS:REQUEST_LOAD_SUBSCRIPTIONS',
  RECEIVE_LOAD_SUBSCRIPTIONS: 'SUBSCRIPTIONS:RECEIVE_LOAD_SUBSCRIPTIONS',
  FAIL_LOAD_SUBSCRIPTIONS: 'SUBSCRIPTIONS:FAIL_LOAD_SUBSCRIPTIONS',
  REQUEST_LOAD_SUBSCRIPTION_OPTIONS: 'SUBSCRIPTIONS:REQUEST_LOAD_SUBSCRIPTION_OPTIONS',
  RECEIVE_LOAD_SUBSCRIPTION_OPTIONS: 'SUBSCRIPTIONS:RECEIVE_LOAD_SUBSCRIPTION_OPTIONS',
  FAIL_LOAD_SUBSCRIPTION_OPTIONS: 'SUBSCRIPTIONS:FAIL_LOAD_SUBSCRIPTION_OPTIONS',
  REQUEST_SAVE_SUBSCRIPTIONS: 'SUBSCRIPTIONS:REQUEST_SAVE_SUBSCRIPTIONS',
  RECEIVE_SAVE_SUBSCRIPTIONS: 'SUBSCRIPTIONS:RECEIVE_SAVE_SUBSCRIPTIONS',
  FAIL_DEFAULT_SUBSCRIPTIONS: 'SUBSCRIPTIONS:FAIL_DEFAULT_SUBSCRIPTIONS',
  REQUEST_LOAD_RESPONSIBLE_FOR_UNIT: 'SUBSCRIPTIONS:REQUEST_LOAD_RESPONSIBLE_FOR_UNIT',
  RECEIVE_LOAD_RESPONSIBLE_FOR_UNIT: 'SUBSCRIPTIONS:RECEIVE_LOAD_RESPONSIBLE_FOR_UNIT',
  FAIL_LOAD_RESPONSIBLE_FOR_UNIT: 'SUBSCRIPTIONS:FAIL_LOAD_RESPONSIBLE_FOR_UNIT',
  REQUEST_LOAD_ALERTS: 'SUBSCRIPTIONS:REQUEST_LOAD_ALERTS',
  RECEIVE_LOAD_ALERTS: 'SUBSCRIPTIONS:RECEIVE_LOAD_ALERTS',
  FAIL_LOAD_ALERTS: 'SUBSCRIPTIONS:FAIL_LOAD_ALERTS'
};

export class RequestLoadSubscriptions {
  public type: string = ACTION.REQUEST_LOAD_SUBSCRIPTIONS;
}

export class ReceiveLoadSubscriptions {
  public type: string = ACTION.RECEIVE_LOAD_SUBSCRIPTIONS;
  public data: SubscriptionStoreValue[];

  constructor(data: SubscriptionStoreValue[]) {
    this.data = data;
  }
}

export class FailLoadSubscriptions {
  public type: string = ACTION.FAIL_LOAD_SUBSCRIPTIONS;
}

export class RequestLoadSubscriptionOptions {
  public type: string = ACTION.REQUEST_LOAD_SUBSCRIPTION_OPTIONS;
}

export class ReceiveLoadSubscriptionOptions {
  public type: string = ACTION.RECEIVE_LOAD_SUBSCRIPTION_OPTIONS;
  public data: ComplexValue<number>[];

  constructor(data: ComplexValue<number>[]) {
    this.data = data;
  }
}

export class FailLoadSubscriptionOptions {
  public type: string = ACTION.FAIL_LOAD_SUBSCRIPTION_OPTIONS;
}

export class RequestSaveSubscriptions {
  public type: string = ACTION.REQUEST_SAVE_SUBSCRIPTIONS;
}

export class ReceiveSaveSubscriptions {
  public type: string = ACTION.RECEIVE_SAVE_SUBSCRIPTIONS;
}

export class FailSubscriptionsExecute {
  public type: string = ACTION.FAIL_DEFAULT_SUBSCRIPTIONS;
}

export class RequestLoadResponsibleForUnit {
  public type: string = ACTION.REQUEST_LOAD_RESPONSIBLE_FOR_UNIT;
}

export class ReceiveLoadResponsibleForUnit {
  public type: string = ACTION.RECEIVE_LOAD_RESPONSIBLE_FOR_UNIT;
  public data: ResponsibleForUnitValues[];

  constructor(data: ResponsibleForUnitValues[]) {
    this.data = data;
  }
}

export class FailLoadResponsibleForUnit {
  public type: string = ACTION.FAIL_LOAD_RESPONSIBLE_FOR_UNIT;
}

export class RequestLoadAlerts {
  public type: string = ACTION.REQUEST_LOAD_ALERTS;
}

export class ReceiveLoadAlerts {
  public type: string = ACTION.RECEIVE_LOAD_ALERTS;
  public data: ComplexValue<number>[];

  constructor(data: ComplexValue<number>[]) {
    this.data = data;
  }
}

export class FailLoadAlerts {
  public type: string = ACTION.FAIL_LOAD_ALERTS;
}
